import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const servicedeskItsmSampleSpaceRoute: InvariantJiraRoute = {
	name: 'servicedesk-itsm-sample-space',
	path: '/jira/servicedesk/itsm-sample-space',
	exact: true,
};
